import { VendorTdsResult, VendorTdsSearch } from "@/types/VendorTds";
import { adminBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

interface VendorTdsResponse {
  name: string;
  user_id: number;
  percentage: number;
  id: number;
}

interface SubCategoryResponse {
  name: string;
  category_id: number;
  company_id: number;
  user_id: number;
  id: number;
}

export const vendorTdsApi = createApi({
  reducerPath: "vendorTdsApi",
  baseQuery: adminBaseQueryWrapper,
  tagTypes: ["vendorTds"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getAllVendorTds: builder.query<VendorTdsResponse[], any>({
      query: () => `/vendor-tds`,
      providesTags: ["vendorTds"],
    }),

    getVendorTdsById: builder.query<any, any>({
      query: ({ id }) => `/vendor-tds/${id}`,
      providesTags: ["vendorTds"],
    }),

    searchVendorTds: builder.query<VendorTdsResult, VendorTdsSearch>({
      query: (input) => ({
        url: `/vendor-tds/search`,
        method: "POST",
        body: input,
      }),
      providesTags: ["vendorTds"],
    }),

    createVendorTds: builder.mutation<void, any>({
      query: (input) => ({
        url: `/vendor-tds`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["vendorTds"],
    }),
    updateVendorTds: builder.mutation<void, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/vendor-tds/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["vendorTds"],
    }),
  }),
});

export const {
  useGetAllVendorTdsQuery,
  useGetVendorTdsByIdQuery,
  useSearchVendorTdsQuery,
  useCreateVendorTdsMutation,
  useUpdateVendorTdsMutation,
} = vendorTdsApi;
